module.exports = __webpack_public_path__ + "static/logo_all-6b690ba800557f7b2ca23ce8ad8dafae.jpg";